<template>
  <span class="inline-block md:hidden" @click="showModal">
    <TwcIcon icon="circle-question" size="sm" type="solid" class="text-gray-500" />
  </span>
  <span v-tooltip="{ html: true, content: sanitizedContentHtml }" class="hidden md:inline-block">
    <TwcIcon icon="circle-question" size="sm" type="solid" class="text-gray-500" />
  </span>

  <TwcModal ref="modal" secondary :title="title" :position="position">
    <template #body>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="font-normal text-base" v-html="sanitizedContentHtml"></div>
    </template>
  </TwcModal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { TwcIcon } from 'transit-web-components'
import TwcModal from '@/components/web-components/TwcModal.vue'
import DOMPurify from 'dompurify'
import { ModalPosition } from 'flowbite-vue/dist/components/FwbModal/types'

const props = defineProps({
  contentHtml: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  position: {
    type: String as () => ModalPosition,
    default: 'top-center'
  }
})

const modal = ref()
const sanitizedContentHtml = computed(() => DOMPurify.sanitize(props.contentHtml))

function showModal() {
  modal.value.open()
}
</script>
